class BlogContents extends HTMLElement {
  connectedCallback() {
    this.innerHTML = '';

    const sectionId = this.dataset.section;
    const contentEl = document.getElementById(`BlogContent-${sectionId}`);
    if (!contentEl) return;

    const headings = Array.from(contentEl.querySelectorAll('h2'));
    if (!headings.length) {
      this.style.display = 'none';
      return;
    }

    const ol = document.createElement('ol');
    ol.className = 'blog-contents__list';

    headings.forEach((h2, idx) => {
      const id = `${sectionId}-${idx + 1}`;
      h2.id = id;

      const li = document.createElement('li');
      li.className = 'blog-contents__item';

      const a = document.createElement('a');
      a.href = `#${id}`;
      a.textContent = h2.textContent ?? '';
      a.className = 'blog-contents__link';

      li.appendChild(a);
      ol.appendChild(li);
    });

    if (this.dataset.heading) {
      const heading = document.createElement('h2');
      heading.textContent = this.dataset.heading;
      this.appendChild(heading);
    }

    this.appendChild(ol);
    this.classList.add('blog-contents--complete');
  }
}

// Prevent customElements re-definition
if (!customElements.get('blog-contents')) {
  customElements.define('blog-contents', BlogContents);
}
